<form (ngSubmit)="onSuccess()" [formGroup]="form">
    <div class="cp5" fxLayout="row wrap" fxLayoutAlign="flex-start center">
        <div fxFlex="100" fxFlex.lt-md="100">
            <app-type-pays
                    [control]="gettype('type')"
                    [label]="pays"
            ></app-type-pays>
        </div>
        <div *ngIf="formtype.get('type').value=='Autre'" fxFlex="100" fxFlex.lt-md="100">
            <app-select-common
                    [code]="CommmCode.nationalite"
                    [control]="get(fields.Nationalite)"
                    [isentagere]="true"
                    [label]="'Nationalité'"
                    [withfiltre]="true"
            ></app-select-common>
        </div>
        <div *ngIf="formtype.get('type').value=='TUN'" fxFlex="100" fxFlex.lt-md="100">
            <app-select-common
                    [code]="CommmCode.categorie"
                    [control]="get(fields.categorie)"
                    [inscrpitipnfo]="true"
                    [label]="'categorie'"
                    [withfiltre]="true"
            ></app-select-common>
        </div>
        <!--    <div
              *ngIf="isPersonnePhysique(get(fields.categorie).value)"
              fxFlex="50"
              fxFlex.lt-md="50"
            >
              <app-type-identifiant [control]="formid.get('cin')">
              </app-type-identifiant>
            </div>-->

        <div *ngIf="formtype.get('type').value=='TUN'" fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.identifiantunique)"
                    [label]="'Identifiant unique'"
                  
            ></app-text-field>
        </div>
        <div *ngIf="formtype.get('type').value!='TUN'" fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.identifiantunique)"
                    [label]="'Identifiant unique'"
                   
            ></app-text-field>
        </div>
        <!--    <div
              fxFlex="50"
              fxFlex.lt-md="100"
              *ngIf="isgroupeArisant(get(fields.categorie).value)"
            >
              <app-text-field
                [control]="get(fields.num_unique_artisan)"
                [label]="'Numéro unique de l\'artisan'"
              ></app-text-field>
            </div>-->
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-select-date
                    [control]="get(fields.date_redac)"
                    [label]="setdate()"
                    [max]="currentDate"
            >
            </app-select-date>
        </div>
        <!--    <div
              fxFlex="25"
              fxFlex.lt-md="100"
              *ngIf="!isPersonnemorale(get(fields.categorie).value)"
            >
              <app-text-field
                [control]="get(fields.matricule_fiscale)"
                [label]="'Matricule fiscal'"
              ></app-text-field>
            </div>-->
        <div *ngIf="formtype.get('type').value=='TUN'" fxFlex="25" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.affilation_cnss)"
                    [label]="'N°affiliation à la C.N.S.S'"
                    [max]="10"
            ></app-text-field>
        </div>
        <div fxFlex="25" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.name_soc)"
                    [label]="'Nom de la société'"
            ></app-text-field>
        </div>

        <div fxFlex fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.name_commerciale)"
                    [label]="'Nom commercial'"
            ></app-text-field>
        </div>


        <div fxFlex fxFlex.lt-md="100">
            <app-select-date
                    [control]="get(fields.open_date)"
                    [label]="'Date ouverture'"
                    [max]="currentDate"
            >
            </app-select-date>
        </div>

        <div fxFlex="100" fxFlex.lt-md="100">
            <!--   *ngIf="isPersonnemorale(get(fields.categorie).value)"-->
            <app-select-common
                
                [code]="CommmCode.categorieActivite"
                [control]="formid.get('id')"
                [label]="'CategorieActivite'"
                [muliple]="true"
            ></app-select-common>
        </div>

        <div fxFlex="100" fxFlex.lt-md="100">
            <app-select-common
                    [code]="CommmCode.formejuridique"
                    [control]="get(fields.forme_jurdique)"
                    [label]="'forme juridique'"
                    [withfiltre]="true"
            ></app-select-common>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.nbrempolye)"
                    [label]="'Nombre employés'"
                    [number]="true"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                #cap
                [control]="get(fields.capitale_social)"
                [formated]="true"
                [label]="'Capital social'"
                [number]="true"
            ></app-text-field>
        </div>
        <div fxFlex="100" fxFlex.lt-md="100">
            <app-select-codepostal
                #sele
                [controladrese]="get('addr1')"
                [controlcode]="get('postCd')"
                [delegation]="sele?.selectDelegationComponent?.mat?.value"
                [entrprise]="!isentrprise(get(fields.categorie)?.value)"
                [etrangere]="get(fields.entreprise_entrangere)"
                [gouvernorat]="sele?.selectGouvernoratComponent?.matselcet?.value"
                [ville]="sele?.selectVilleBygouvandDelComponent?.matselect?.value"
            ></app-select-codepostal>
        </div>
        <div fxFlex="100" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.adresse2)"
                    [label]="'adress2'"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                #tele
                [control]="get(fields.Num_tel)"
                [label]="'tel_fixe'"
                [numberphone]="true"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.Num_fax)"
                    [label]="'fax'"
                    [numberphone]="true"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get(fields.page)"
                    [label]="'site_web'"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="formemail.get('emailreg')"
                    [label]="'Email pour la notification du résultat'"
            ></app-text-field>
        </div>
    </div>

    <div fxLayoutAlign="end end" mat-dialog-actions>
        <app-spinner-container>
            <button color="primary" mat-raised-button>
                <span translate>submit</span>
            </button>
        </app-spinner-container>
    </div>
</form>
